import {useState, useEffect, useRef} from 'react'

export const useIsElementDark = () => {
  const [isDarkMode, setIsDarkMode] = useState(false)
  const ref = useRef<SVGSVGElement>(null)

  useEffect(() => {
    const element = ref.current

    if (!element) return

    const updateDarkMode = () => {
      const closestElementWithTheme = element.closest<HTMLElement>('[data-theme]')
      if (closestElementWithTheme) {
        const isDark = closestElementWithTheme.getAttribute('data-theme') === 'translated-dark'
        setIsDarkMode(isDark)
      }
    }

    updateDarkMode()

    const observer = new MutationObserver(updateDarkMode)

    const closestElementWithTheme = element.closest<HTMLElement>('[data-theme]')
    if (closestElementWithTheme) {
      observer.observe(closestElementWithTheme, {attributes: true, attributeFilter: ['data-theme']})
    }

    return () => observer.disconnect()
  }, [])

  return {ref, isDarkMode}
}
